import { render, staticRenderFns } from "./ModalCancel.vue?vue&type=template&id=3bc1dcb4&scoped=true&"
import script from "./ModalCancel.vue?vue&type=script&lang=js&"
export * from "./ModalCancel.vue?vue&type=script&lang=js&"
import style0 from "./ModalCancel.vue?vue&type=style&index=0&id=3bc1dcb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1dcb4",
  null
  
)

export default component.exports